/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const PenaltyHistory = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const [user, setUser] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  let [limit, setLimit] = useState(10);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  const fetchData = () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    axios
      .get(baseUrl + `txn/penaltybyadmin/all?page=${pageNumber}&_limit=${limit}`, { headers })
      .then((res) => {
        setUser(res.data.admin);
        setNumberOfPages(res.data.totalPages);
      });
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "long", day: "numeric", hour: "numeric", hour12: true, minute: "numeric",
    });
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, limit]);

  if (user === undefined) return null;

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-penalty { background: linear-gradient(45deg, #c0392b, #e74c3c); padding: 20px; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
    .controls-bar { display: flex; justify-content: flex-end; padding: 15px 20px; background: #fafafa; border-bottom: 1px solid #eee; }
    .select-limit { padding: 8px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 0.9rem; outline: none; background: white; color: #333; cursor: pointer; }
    .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
    .custom-table { width: 100%; border-collapse: collapse; min-width: 800px; }
    .custom-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px 20px; text-align: left; border-bottom: 2px solid #eee; }
    .custom-table tbody td { padding: 15px 20px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.9rem; }
    .custom-table tbody tr:hover { background: #fafafa !important; }
    .id-cell { font-family: monospace; color: #666; font-size: 0.85rem; }
    .amount-penalty { font-weight: 700; color: #e74c3c !important; }
    .status-badge-penalty { background: #fdecea; color: #c0392b; padding: 4px 10px; border-radius: 20px; font-weight: 700; font-size: 0.75rem; text-transform: uppercase; }
    .btn-link-user { color: #c0392b; text-decoration: none; font-weight: 600; background: #fdecea; padding: 5px 10px; border-radius: 6px; font-size: 0.85rem; transition: 0.2s; }
    .btn-link-user:hover { background: #f5b7b1; }
    .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
    .page-item { display: inline-block; }
    .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
    .page-link:hover { background: #f9f9f9; color: #c0392b !important; }
    .active .page-link { background: #c0392b; color: white !important; border-color: #c0392b; box-shadow: 0 4px 10px rgba(192,57,43,0.3); }
  `;

  return (
    <div className="admin-mgmt-page">
      <style>{styles}</style>
      <div className="row">
        <div className="col-12">
          <div className="modern-card">
            <div className="card-header-penalty">
              <h4 className="card-title-custom">🔴 Penalty History</h4>
            </div>
            <div className="controls-bar">
              <select className="select-limit" onChange={setpageLimit}>
                <option value="10">10 Rows</option>
                <option value="20">20 Rows</option>
                <option value="50">50 Rows</option>
                <option value="100">100 Rows</option>
                <option value="500">500 Rows</option>
              </select>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Phone</th>
                    <th>User Name</th>
                    <th>Amount Deducted</th>
                    <th>Reason</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {user && user.map((data, key) => (
                    <tr key={key}>
                      <td style={{ color: "#999", fontWeight: "bold" }}>
                        {(pageNumber === 0 ? 0 : pageNumber - 1) * limit + (key + 1)}
                      </td>
                      <td className="id-cell">{data._id}</td>
                      <td>{data.User_id ? data.User_id.Phone : "-"}</td>
                      <td>
                        {data.User_id ? (
                          <Link className="btn-link-user" to={`/user/view_user/${data.User_id._id}`}>
                            {data.User_id.Name}
                          </Link>
                        ) : <span style={{ color: "#999" }}>N/A</span>}
                      </td>
                      <td className="amount-penalty">-₹{data.amount}</td>
                      <td><span className="status-badge-penalty">{data.status || "Penalty"}</span></td>
                      <td style={{ fontSize: "0.9rem", color: "#666" }}>{dateFormat(data.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="p-3">
              <ReactPaginate
                previousLabel={"← Prev"}
                nextLabel={"Next →"}
                breakLabel={"..."}
                pageCount={numberOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenaltyHistory;
